import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Host, Menu, MenuItem, AppService} from "../../../../common";
import {Cart} from "../../../../common";
import {Subscription} from "rxjs";

@Component({
  standalone: false,
  template: `
    <app-header [host]="host" [cart]="cart"></app-header>
    <breadcrumb [item]="item"></breadcrumb>
    <main class="container" *ngIf="item">
      <menu-item [menu]="menu" [cart]="cart" [item]="item"></menu-item>
    </main>
  `
})
export class MenuItemPage implements OnInit, OnDestroy {

  host: Host = null;
  menu: Menu = null;
  cart: Cart = null;
  item: MenuItem;

  private subscriptions: Array<Subscription> = [];

  constructor(
    private route: ActivatedRoute,
    private appService: AppService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = parseInt(params.get('itemid'));
      this.subscriptions.push(
        this.appService
          .load()
          .subscribe(({host, menu, cart}) => {
            this.host = host;
            this.menu = menu;
            this.item = (id) ? this.menu.items[id] : null;
            this.cart = cart;
          })
      );
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    })
  }
}
